module.exports = __webpack_public_path__ + "static/media/2025_Gronlands_Banken.6383f76d.png";